import { h, FunctionalComponent, Fragment } from 'preact';

import { RatingsContainer, RatingsContainerButton } from './rating-bar.styles';
import RatingIcons from '@components/atoms/icon/rating-icons';
import RatingbarState, { Rating } from '@state/ratingbarState';

type IRatingsItem = {
  value: string;
  order: number;
  text: string;
};

export interface RatingBarProps {
  onSelect?: (selectedRating: Rating, ratingNumber: number) => void;
}

const ratings: IRatingsItem[] = [
  {
    value: 'hate',
    order: 1,
    text: 'Hate',
  },
  {
    value: 'confused',
    order: 2,
    text: 'Dislike',
  },
  {
    value: 'neutral',
    order: 3,
    text: 'Neutral',
  },
  {
    value: 'happy',
    order: 4,
    text: 'Like',
  },
  {
    value: 'excited',
    order: 5,
    text: 'Love',
  },
];

const RatingBar: FunctionalComponent<RatingBarProps> = ({ onSelect }) => {
  const { ratingbar, resetRatingbarState } = RatingbarState.value;

  const handleRatingSelected = (value: Rating) => {
    ratingbar.value.rating.value = value;
  };

  const handleRatingClicked = (rating: IRatingsItem) => {
    if (ratingbar.value.rating.value == rating.value) {
      resetRatingbarState();
    } else {
      handleRatingSelected(rating.value as Rating);
    }
    onSelect?.(rating.value as Rating, rating.order);
  };

  return (
    <RatingsContainer className="rating-bar-container">
      {ratings.map((rating) => (
        <RatingsContainerButton onClick={() => handleRatingClicked(rating)}>
          <Fragment>
            <RatingIcons
              type={rating.value}
              filled={ratingbar.value.rating.value == rating.value}
              disabled={
                ratingbar.value.rating.value != rating.value &&
                ratingbar.value.rating.value != 'initial'
              }
            />
            {ratingbar.value.rating.value == rating.value && <p>{rating.text}</p>}
          </Fragment>
        </RatingsContainerButton>
      ))}
    </RatingsContainer>
  );
};

export default RatingBar;
